import { createApp } from 'vue'
import App from './App.vue'
// import DevUI from 'vue-devui';
// import 'vue-devui/style.css';
// import '@devui-design/icons/icomoon/devui-icon.css';
// import { ThemeServiceInit, infinityTheme } from 'devui-theme';
// ThemeServiceInit({ infinityTheme }, 'infinityTheme');

// createApp(App).use(DevUI).mount('#app');

import Select from 'vue-devui/editable-select';
import 'vue-devui/editable-select/style.css';

createApp(App).use(Select).mount('#app');

// createApp(App).mount('#app')
